var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"outline":"","items":_vm.modules,"item-text":"module","item-value":"module","label":_vm.$t('fileManager.labels.selectModule')},model:{value:(_vm.selectedModule),callback:function ($$v) {_vm.selectedModule=$$v},expression:"selectedModule"}})
}
var staticRenderFns = []

export { render, staticRenderFns }